import { graphql } from "@apollo/client/react/hoc"
import BlankButton from "@pathwright/ui/src/components/button/BlankButton"
import Button from "@pathwright/ui/src/components/button/Button"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import CardLink from "@pathwright/ui/src/components/card/CardLink"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Screensize from "@pathwright/ui/src/components/ui/Screensize"
import Text from "@pathwright/ui/src/components/ui/Text"
import get from "lodash/get"
import moment from "moment"
import PropTypes from "prop-types"
import { useLayoutEffect, useState } from "react"
import LazyAdaptedSignedInContainer from "../../auth/LazyAdaptedSignedInContainer"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import SignupFlow from "../../signup/SignupFlow"
import { createPaginator, flattenEdges } from "../../utils/apollo"
import USER_SCHOOL_RESOURCE_LICENSES_QUERY from "./graphql/user-school-resource-licenses-query"

const LicenseResourceSchoolGate = (props) => {
  const { error, loading, memberships, hasMore, loadMore } = props
  const [creating, setCreating] = useState()
  const { school } = usePathwrightContext()

  useLayoutEffect(() => {
    if (
      !error &&
      !loading &&
      !(memberships && memberships.length > 0) &&
      !creating
    ) {
      setCreating(true)
    }
  })

  if (creating) {
    return (
      <div style={{ padding: "0 20px 20px", position: "relative" }}>
        <SignupFlow
          licensorId={school.id}
          onStepChanged={(step) => {}}
          onSchoolCreated={props.onSelectSchool}
          namePlaceholder={`"Grace Church, Emmanuel Elder Training, Edwards Family…"`}
          renderNav={() => (
            <Button
              styleType="blank"
              style={{ position: "absolute", zIndex: 1, top: 20, left: 20 }}
              onClick={() => setCreating(false)}
            >
              <Pathicon icon="arrow-left" />
              Back
            </Button>
          )}
          renderHeader={() => <LazyAdaptedSignedInContainer />}
          renderSubmit={({ step, ...submitProps }) => (
            <SubmitButton {...submitProps} styleType="primary" size="large">
              Create Account
            </SubmitButton>
          )}
        />
      </div>
    )
  }

  const isToday = (date) => moment(date).isSame(moment(), "day")
  return (
    <div>
      <LazyAdaptedSignedInContainer />
      <div style={{ position: "relative", minHeight: 100 }}>
        {error ? (
          <Text.Meta>An unexpected error occurred.</Text.Meta>
        ) : loading ? (
          <LoadingCircle />
        ) : memberships && memberships.length > 0 ? (
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <Text.Body style={{ margin: "10px 25px" }}>
              Which Pathwright account would you like add this curriculum to?
            </Text.Body>
            <li style={{ padding: "0 25px" }}>
              <BlankButton onClick={() => setCreating(true)}>
                Create a new Pathwright account
              </BlankButton>
            </li>
            {memberships.map((membership, index) => (
              <li key={membership.id}>
                <CardLink
                  disabled={!!membership.school.resource_license}
                  onClick={() => props.onSelectSchool(membership.school)}
                  image={membership.school.image}
                  label={
                    <span style={{ cursor: "pointer" }}>
                      {membership.school.name}{" "}
                      {isToday(membership.school.created) ? (
                        <span
                          style={{
                            fontStyle: "italic",
                            color: "blue"
                          }}
                        >
                          New
                        </span>
                      ) : null}{" "}
                    </span>
                  }
                  borderTop={index > 0}
                  meta={
                    membership.school.resource_license ? (
                      <span
                        style={{
                          fontStyle: "italic",
                          color: "red",
                          pointerEvents: "none"
                        }}
                      >
                        Already licensed this curriculum
                      </span>
                    ) : (
                      <Screensize.Consumer>
                        {(screensize) => (
                          <span>
                            {screensize !== "sm" &&
                              "Curriculum will be available at "}
                            {membership.school.url}
                          </span>
                        )}
                      </Screensize.Consumer>
                    )
                  }
                />
              </li>
            ))}
            {hasMore && (
              <Button styleType="card" onClick={loadMore}>
                Load more
              </Button>
            )}
          </ul>
        ) : null}
      </div>
    </div>
  )
}

LicenseResourceSchoolGate.displayName = "LicenseResourceSchoolGate"

LicenseResourceSchoolGate.propTypes = {
  onSelectSchool: PropTypes.func.isRequired
}

export default graphql(USER_SCHOOL_RESOURCE_LICENSES_QUERY, {
  options: ({ me, license_offering }) => ({
    fetchPolicy: "network-only",
    variables: {
      id: me.id,
      role: "administrator",
      license_offering_id: license_offering.id,
      sso_link_pathname: "/home/teach/"
    }
  }),
  props: ({ data }) => ({
    error: data.error,
    loading: data.loading,
    hasMore: get(data, "user.memberships.pageInfo.hasNextPage"),
    loadMore: createPaginator(data, "user.memberships"),
    memberships: flattenEdges(get(data, "user.memberships"))
  })
})(LicenseResourceSchoolGate)
